import React, { createContext, useContext } from 'react';
import { User } from '../../types';
import { Promo } from './types';

export const BannerContext = createContext(undefined);

const PromoList: Promo[] = [];

export const withPromo = (Component) => (props: { loading: boolean; user: User }) => {
  const promo =
    PromoList.find(
      ({ isPromoAvailable = () => false, isDiscountVisible = () => false }) =>
        isPromoAvailable(props) || isDiscountVisible(props),
    ) || ({} as Partial<Promo>);

  return (
    <BannerContext.Provider value={{ ...promo }}>
      <Component {...props} />
    </BannerContext.Provider>
  );
};

export const usePromoDiscount = (props) => {
  const promoData: Partial<Promo> = useContext(BannerContext) || {};

  if (promoData.isDiscountVisible && promoData.isDiscountVisible(props)) {
    return {
      coupon: promoData.coupon,
      getDiscount: promoData.getDiscount,
    };
  }

  return {
    coupon: '',
    discount: null,
    getDiscount: () => 0,
  };
};
